export const API_BASE_URL =
  "https://triverseadvertising.com/arsus_website/admin-portal/api/";
